import { withStyles } from "@material-ui/core";
import MuiExpansionPanel from "@material-ui/core/ExpansionPanel";
import MuiExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import MuiExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";

export const ExpansionPanel = withStyles({
    root: {
        border: "1px solid #b7b7b7",
        boxShadow: "none",
        backgroundColor: "#f2f2f2",

        "&:not(:last-child)": {
            borderBottom: 0
        },
        "&:before": {
            display: "none"
        },
        "&$expanded": {
            margin: "auto"
        },
        fontSize: "13px"
    },
    expanded: {}
})(MuiExpansionPanel);

export const ExpansionPanelSummary = withStyles({
    root: {
        marginBottom: -1,
        "&$expanded": {
            minHeight: 56
        },
        padding: "0px 15px 0px 15px",


    },
    content: {
        "&$expanded": {
            margin: "12px 0"
        },

    },
    expanded: {}
})(MuiExpansionPanelSummary);

export const ExpansionPanelDetails = withStyles(({
    root: {
        padding: "10px 15px 20px 15px"
    }
}))(MuiExpansionPanelDetails);
